<template>
  <div>
    <div class="container">
      <div class="inner">
        <div class="top-bar">
          <h1 class="main-title">Czym jest <span class="orange">Błyskawiczne doładowanie</span>?</h1>
          <p>To doładowanie za które zapłacisz jednym kliknięciem bez przekierowania do serwisu transakcyjnego banku. Wystarczy, że się zalogujesz i zapamiętasz kod BLIK lub kartę płatniczą by doładować telefon szybciej, niż kiedykolwiek.</p>

          <h2>Instrukcja krok po kroku jak podpiąć BLIKa lub kartę płatniczą.</h2>

          <h3>1. Zarejestruj się i zaloguj na doladowania.orange.pl</h3>
          <p>By zacząć korzystanie z <span class="orange">Błyskawicznego Doładowania</span> zarejestruj się na doładowania.orange.pl. Pamiętaj o zalogowaniu zawsze, gdy będziesz korzystać z <span class="orange">Błyskawicznego Doładowania</span>.</p>

          <h3>2. Podepnij BLIKa lub kartę płatniczą</h3>

          <h4><span class="orange">Błyskawiczne doładowanie</span> BLIKiem</h4>
          <div class="quick-topup-box">
            <img src="/images/orange/quick-topup-blik.png" alt="Błyskawiczne doładowanie BLIK">
            <ul>
              <li>Zaloguj się a następnie wybierz numer, który chcesz doładować oraz kwotę doładowania.</li>
              <li>Użyj kodu BLIK i zaznacz zgodę na zapamiętanie formy płatności (Dane BLIK będą bezpiecznie przechowywane na Twoim koncie).</li>
              <li>To już wszystko! Kolejne doładowanie zrealizujesz w kilka sekund - po zalogowaniu, wybraniu numeru i kwoty doładowania - płatność zatwierdzisz przyciskiem <strong>"Zapłać&nbsp;zapisanym&nbsp;BLIKiem"</strong>.</li>
            </ul>
          </div>

          <h4><span class="orange">Błyskawiczne doładowanie</span> kartą płatniczą</h4>
          <div class="quick-topup-box">
            <img src="/images/orange/quick-topup-card.png" alt="Błyskawiczne doładowanie kartą płatniczą">
            <ul>
              <li>Zaloguj się a następnie wybierz numer, który chcesz doładować oraz kwotę doładowania.</li>
              <li>Dodaj kartę płatniczą - uzupełnij formularz i zaznacz zgodę na zapamiętanie tej formy płatności (dane karty użytej będą bezpiecznie przechowywane na Twoim koncie.)</li>
              <li>To już wszystko! Kolejne doładowanie zrealizujesz w kilka sekund - po zalogowaniu, wybraniu numeru i kwoty doładowania - płatność zatwierdzisz przyciskiem <strong>"Zapłać&nbsp;zapisaną&nbsp;kartą"</strong>.</li>
            </ul>
          </div>

          <h3>3. Doładuj telefon</h3>
          <p>Gdy masz zapamiętany BLIK lub kartę płatniczą doładowanie trwa tylko kilka sekund, a dodatkowo zawsze <span class="orange">otrzymasz 5 GB</span>. Sprawdź jakie to proste.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'QuickTopupView'
}
</script>

<style lang="scss" src="../../assets/scss/components/_quick_topup-main.scss" scoped></style>
